import React from 'react';
import PropTypes from 'prop-types';
import { LoadingSpinner } from 'yankees-react-utils';
import { useOktaQuery, useOktaQueries, Advance, HeatMaps } from '../../../data';
import PitchExecutionTable from './PitchExecutionTable';
import usePlayerSelector from '../../../utils/usePlayerSelector';

const PitchExecutionPitcher = ({ pitcherId, vsTeamId, teamId, yearid, pitches, arePitchesLoading, isReviewLoading, isInBats, venueId, ...rest }) => {
    const player = usePlayerSelector();
    const { data: ctwb, isLoading } = useOktaQuery(
        ['ctwb', pitcherId, vsTeamId],
        (t) => Advance.ctwb(t, { pitcherId, vsTeamId, teamId, venueId }),
        { enabled: !!pitcherId },
    );

    const batterIds = [...new Set(pitches?.map((p) => p.batterid))];
    const heatMapImagesQueries = useOktaQueries(batterIds.map((id) => ({
        queryKey: ['catcher-wristband', pitcherId, id, yearid],
        queryFn: (t) => HeatMaps.catcherWristband(t, pitcherId, id, yearid, { venueid: player.Team?.Level?.LevelID === 8 ? venueId : 0 }),
        retry: false,
        enabled: !!pitcherId,
    })));

    if (!pitcherId || isLoading || arePitchesLoading || isReviewLoading || heatMapImagesQueries.some((q) => q.isLoading)) {
        return (
            <div className="m-2 d-flex justify-content-center">
                <LoadingSpinner />
            </div>
        );
    }

    const heatMaps = heatMapImagesQueries.flatMap((q) => q.data || []);
    return (
        <PitchExecutionTable
            playerid={pitcherId}
            pitches={pitches}
            ctwb={ctwb}
            heatMaps={heatMaps}
            isInBats={isInBats}
            {...rest}
        />
    );
};

PitchExecutionPitcher.propTypes = {
    pitcherId: PropTypes.number,
    vsTeamId: PropTypes.number.isRequired,
    teamId: PropTypes.number.isRequired,
    yearid: PropTypes.number.isRequired,
    pitches: PropTypes.arrayOf(PropTypes.shape({
        batterid: PropTypes.number.isRequired,
    })),
    arePitchesLoading: PropTypes.bool,
    isReviewLoading: PropTypes.bool,
    isInBats: PropTypes.bool,
    venueId: PropTypes.number.isRequired,
};
PitchExecutionPitcher.defaultProps = {
    pitcherId: undefined,
    pitches: [],
    arePitchesLoading: true,
    isReviewLoading: true,
};

export default PitchExecutionPitcher;
